import { async } from "q";
import axiosClient from "./axiosClient";


const MedicineStoreService = {

  getListPrescription1: async (params) => {
    const url = `store/prescription/search-key`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  getListMedicineByName: async (name) => {
    const params = { name: name }
    const url = `store/medicine/by-name-like`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },

  getListPatient: async (hoTen) => {
    const params = { hoTen: hoTen }
    const url = `qlkhambenh/benh-nhan/lay-bang-ho-ten`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },

  getListMedicineInStoreByName: async (params) => {

    const url = `store/medicine-store/by-ten-thuoc`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  getDetailPrescription: async (id) => {
    const url = `store/prescription/by-id`;
    const params = {
      id: id
    }
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  getDetailLo: async (soLo) => {
    const url = `store/medicine-store/by-so-lo?so-lo=${soLo}&-kho-id=6`;

    const response = await axiosClient.get(url);
    return response.data;
  },
  getListLoByMedicineName: async (name) => {
    const url = `store/medicine-store/by-ten-thuoc?ten-thuoc=${name}&kho-id=6`;

    const response = await axiosClient.get(url);
    return response.data;
  },

  getListUnitByMedicineId: async (id) => {
    const url = `store/unit-conversion/by-thuoc-id?thuoc-id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },

  createAndPayPrescription: async (params) => {
    const url = `store/prescription/prescription-sales`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  returnMedicine: async (params) => {
    const url = `store/prescription/phieu-tra-thuoc`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  layDanhMucThuoc: async (params) => {
    const url = `store/medicine/list-medicine`;
    const response = await axiosClient.get(url, params);
    return response.data;
  },
  getListPayments: async (params) => {
    const url = `store/payments/list-payments`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListLoaiThuoc: async (params) => {
    const url = `/store/medicine-type/list-medicine-type`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  }






















  // getMedicineList: async (params) => {
  //   const url = `store/medicine-store/list-medicine-store?page=1&limit=10`;
  //   const response = await axiosClient.get(url, {
  //     params: params,
  //   });
  //   return response;
  // },

  // /// Kho thuốc
  // getListMedicine: async (page, pageSize) => {
  //   const url = `store/medicine/list-medicine`;
  //   const params = {
  //     page: page,
  //     limit: pageSize
  //   }
  //   const response = await axiosClient.get(url, {
  //     params: params,
  //   });
  //   return response;
  // },

}

export default MedicineStoreService;